/* @flow weak */
import Container from 'components/Container.jsx';
import CurrentUser from 'auth/CurrentUser';
import GroupCreateModal from './GroupCreateModal.jsx';
import JoinGroupModal from './JoinGroupModal.jsx';
import Link from 'components/Link.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import TitleHeader from 'components/TitleHeader.jsx';
import React from 'react';
import getRedirectLocationAfterGroupCreation from 'utils/getRedirectLocationAfterGroupCreation';
import getRedirectLocationAfterGroupJoin from 'utils/getRedirectLocationAfterGroupJoin';

import cx from 'classnames';

import './styles/NoGroupsView.scss';

class NoGroupsView extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  handleGroupCreated = (group) => {
    this.context.router.push(getRedirectLocationAfterGroupCreation(group));
  };

  handleGroupJoined = (group) => {
    this.context.router.push(getRedirectLocationAfterGroupJoin(group));
  };

  renderSubtext = () => {
    const groupCreateModal = <GroupCreateModal onCreate={this.handleGroupCreated} />;
    const joinGroupModal = <JoinGroupModal onJoin={this.handleGroupJoined} />;

    const user = CurrentUser.getUser();

    if (user.canCreateGroups()) {
      if (user.isTeacher()) {
        return (
          <div>
            <ModalTrigger modal={groupCreateModal}>
              <Link>Create a class</Link>
            </ModalTrigger>
            {' '}
            or
            {' '}
            <ModalTrigger modal={joinGroupModal}>
              <span>
                <Link>join a class</Link>
                {' '}
                to start using Remind.
              </span>
            </ModalTrigger>
          </div>
        );
      } else {
        return (
          <div>
            <ModalTrigger modal={groupCreateModal}>
              <Link>Create a class</Link>
            </ModalTrigger>
            {' '}
            to stay connected with your clubs, teams, organizations, and more!
          </div>
        );
      }
    }

    return (
      <div>
        <ModalTrigger modal={joinGroupModal}>
          <span>
            <Link>Join a class</Link>
            {' '}
            to start using Remind.
          </span>
        </ModalTrigger>
      </div>
    );
  };

  render() {
    return (
      <div className={cx('NoGroupsView', this.props.className)}>
        <Container size="small">
          <TitleHeader
            glyph="remind-icon"
            title="Get started!"
            subtext={this.renderSubtext()}
            size="xxlarge"
          />
        </Container>
      </div>
    );
  }
}

export default NoGroupsView;



// WEBPACK FOOTER //
// ./src/groups/components/NoGroupsView.jsx